import React from "react";
import moment from "moment";

import { DetailField, CopyableField, Stars, humanize } from "../detailFields";
import "../superRide.css";

const averageRate = (comment) => {
  const rates = (comment.readyComments || [])
    .map((r) => r.rate)
    .filter((r) => typeof r === "number");
  if (!rates.length) return null;
  return rates.reduce((sum, r) => sum + r, 0) / rates.length;
};

/**
 * CommentDetails - content-only, rendered inside a DialogShell.
 *
 * Told which side of the review it is showing rather than hard-coding
 * driver/passenger, so one component serves both queues. The previous
 * version was driver-only and left a `console.log` of the passenger
 * comment field on every render.
 */
const CommentDetails = ({
  comment,
  commentField,
  subjectLabel,
  authorLabel,
  subjectKey,
  authorKey,
}) => {
  const subject = comment[subjectKey];
  const author = comment[authorKey];
  const rate = averageRate(comment);
  const tags = comment.readyComments || [];

  const person = (value) =>
    value ? (
      <React.Fragment>
        {value.fullName}
        <br />
        <span className="superRideMuted">{value.phoneNumber}</span>
      </React.Fragment>
    ) : null;

  return (
    <div className="superRideDetails superRideDetailsNarrow">
      <div className="superRideDetailsTop">
        <Stars value={rate} />
      </div>

      <div className="superRideGrid">
        <DetailField label={subjectLabel} value={person(subject)} />
        <DetailField label={authorLabel} value={person(author)} />
        <DetailField
          label="Left"
          value={moment(comment.createdAt).format("MMM D, YYYY [at] hh:mm A")}
        />
        <DetailField
          label="Trip"
          value={
            comment.trip
              ? `${humanize(comment.trip.tripType)}${
                  comment.trip.cost ? ` · $${Number(comment.trip.cost).toFixed(2)}` : ""
                }`
              : null
          }
        />
        <CopyableField label="Review ID" value={comment._id} />
        <CopyableField label="Trip ID" value={comment.trip && comment.trip._id} />
      </div>

      {tags.length > 0 && (
        <div className="superRideField">
          <span className="superRideLabel">Ratings given ({tags.length})</span>
          <div className="superRideReceipt">
            {tags.map((tag, index) => (
              <div className="superRideReceiptRow" key={`${index}`}>
                <span>{(tag.readyComment && tag.readyComment.type) || "Overall"}</span>
                <span>
                  <Stars value={tag.rate} showValue={false} />
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <DetailField
        label="Comment"
        wide
        value={comment[commentField] || <span className="superRideMuted">No written comment</span>}
      />
    </div>
  );
};

export default CommentDetails;
